// Events
import {
  CART_CHANGED,
  CART_LOADING,
  MODAL_OPEN,
  MOUNT_COMPONENTS,
  THEME_CART_UPDATED,
} from 'events';
// Lib
import PhillRecommendations from 'lib/PhillRecommendations';
import Tracking from 'lib/tracking';
import { component } from 'picoapp';
import Swiper, { A11y, Autoplay, Manipulation, Mousewheel, Navigation, Scrollbar } from 'swiper';

// Utils
import choozy from 'utils/choozy';
import { hide, show } from 'utils/node';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar]);

export default component((node, ctx) => {
  const { closeButton, swiperCarousel } = choozy(node);
  const { cart: initialCart } = ctx.getState();

  const { type } = node.dataset;

  const { recommendationsType, fallbackRecommendationsType } = window.theme.cartSettings;

  const recommendationType = [recommendationsType, fallbackRecommendationsType, 'related']; // If the first recommendationn type doesn't work, we try the next

  let preventRender = false;
  let initialized = false;

  const recommendations = new PhillRecommendations({
    sectionId:
      type === 'cart-drawer'
        ? 'cart-product-recommendations-shopify'
        : 'cart-page-product-recommendations-shopify',
    itemQuery: '[data-recommendation-item]',
    compilationTemplate:
      type === 'cart-drawer' ? 'recommendation-items' : 'recommendation-products',
  });

  const update = async (items = [], options = null) => {
    if (items.length === 0 || preventRender) {
      node.classList.remove('is-loading');
      return;
    }

    try {
      const [slides] = await recommendations.query([recommendationType[0], items]);

      swiperCarousel.dispatchEvent(new CustomEvent('replace-slides', { detail: { slides } }));

      show(node);

      node.classList.remove('is-loading');

      ctx.emit(MOUNT_COMPONENTS);
    } catch (err) {
      if (err.name === 'ApiError') {
        recommendationType.shift();

        update(items, options);
        return;
      }
    }

    if (options?.tracking)
      Tracking.trackViewItemList({
        products: Array.from(node.querySelectorAll('[data-product-item-container]')).map((item) =>
          JSON.parse(item.dataset.productItem || '{}'),
        ),
        placement: 'recommendations',
      });
  };

  const init = (options) => {
    update(initialCart.items, options);
    initialized = true;
    node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, false));
  };

  ctx.on([CART_LOADING, CART_CHANGED], () => {
    node.classList.add('is-loading');
  });

  ctx.on(THEME_CART_UPDATED, ({ cart }) => {
    update(cart.items, { tracking: true });
  });

  ctx.on(MODAL_OPEN, (state, { id, props }) => {
    if (id !== 'cart') return;

    if (!initialized) {
      init({ tracking: props?.action !== 'add_to_cart' });
    }

    preventRender = false;
    show(node);
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      preventRender = true;
      hide(node);
      update();
    });
  }

  if (type === 'cart-page') {
    init();
  }
});
